import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import { DropdownButton } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { IconHamburger } from 'svgIcons/MotionPortalIcons';
import useMainMenuOptions from './useMainMenuOptions';
import useModalOptions from './useModalOptions';
import { ModalPicker } from './ModalPicker';
import useUserCapability from 'sharedHooks/useUserCapability';
import { routes } from 'routes';
import { useSelector } from 'react-redux';

const MainMenuDropdownComponent = ({
    actions,
    menuBarFits,
    menuBarItems,
    isNonPowertrainOrganization
}) => {
    const { t: translate } = useTranslation();
    const broadcastMessagesInfo = useSelector((state) => state.overview.getBroadcastMessagesView?.data);
    const pdfContent = broadcastMessagesInfo?.length > 0 ? broadcastMessagesInfo[0]?.pdfPath : null;
    const userCapabilityHelper = useUserCapability();
    const acknowledgeEULA = () => {
        actions.acceptEULA();
    };

    const [modalVisible, setModalVisible] = useState();
    const [currentModal, setCurrentModal] = useState({ modalType: 'pdf' });
    const mainMenus = useMainMenuOptions(setModalVisible, setCurrentModal);

    const closeModal = () => {
        setModalVisible(false);
        setCurrentModal({ ...currentModal, pdfContent: null });
    };

    useModalOptions(setModalVisible, setCurrentModal, { EULA: acknowledgeEULA }, closeModal);

    const renderMainMenuItems = () =>
        mainMenus.map((option, key) =>
            <Dropdown.Item
                key={key}
                {...(option.href && { href: option.href, target: '_blank' })}
                {...(option.onClick && { onClick: option.onClick })}
            >
                {translate(option.label)}
            </Dropdown.Item>);

    const renderMenuBarItems = () => {
        const isREC = userCapabilityHelper.hasHomePageRecCapability(); /* FALSE FOR LSU AND END USER | TRUE FOR REC USER */
        const isLSU = userCapabilityHelper.hasFleetOverviewCapability() || userCapabilityHelper.hasHomePageCapability();
        let menuItems = [...menuBarItems]; // Create a shallow copy to avoid mutating the original array
        if (!isREC && !isLSU) {
            menuItems = menuItems?.filter(item => item.route !== routes.FleetDashboard);
        }
        if (isNonPowertrainOrganization) {
            menuItems = menuItems?.filter(item => item.route === routes.Tools);
        }
        return !menuBarFits &&
            <>
                {
                    menuItems.map((menuBarItem, key) =>
                        <Dropdown.Item key={key} as={NavLink} to={menuBarItem.route}>{translate(menuBarItem.title)}</Dropdown.Item>)
                }
                <Dropdown.Divider />
            </>;
    };

    return (
        <>
            <DropdownButton
                className='right-dropdown-menu'
                title={<IconHamburger color='black' />}
            >
                {renderMenuBarItems()}
                {renderMainMenuItems()}
            </DropdownButton>
            <ModalPicker
                show={modalVisible}
                modalType={currentModal.modalType}
                closeModal={closeModal}
                modalMetadata={{ ...currentModal.modalMetadata }}
                pdfContent={pdfContent}
            />
        </>
    );
};

MainMenuDropdownComponent.propTypes = {
    actions: PropTypes.shape({
        acceptEULA: PropTypes.func.isRequired
    }).isRequired,
    menuBarFits: PropTypes.bool.isRequired,
    menuBarItems: PropTypes.arrayOf(PropTypes.shape({
        route: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired
    })).isRequired,
    isNonPowertrainOrganization: PropTypes.bool
};

export default MainMenuDropdownComponent;
